'use strict'

import React from 'react'
import { Link } from 'react-router'

class NotFound extends React.Component {
  componentDidMount () {
    document.title = 'FAQ not found | Go Argos'
  }

  render () {
    return (
      <div id='helpfaq' className='faq page container'>
        <div id='helpfaqcontent' tabIndex='-1' />
        <div className='container ask-tpl-container'>
          <h2 className='page__title'>FAQ not found</h2>
          <p className='page__content'>The requested FAQ could not be found</p>
          <p>
            <Link to='/help/' className='faq__button faq__button--back-to-help-home'>
              <span className='argos-icon icon-UIE-Controls-Chevron-Left' aria-hidden='true' />
              Back to help home
            </Link>
          </p>
        </div>
      </div>
    )
  }
}

export default NotFound
